import React, { lazy, useContext } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';

import BludotLogo from 'src/assets/images/open-america-rewards-logo.png';
import LayoutCarousel from 'src/components/LayourCarousel';
import { AppViewContext } from 'src/containers/Core/AppView';
import { FORGOT_PASSWORD, SET_PASSWORD, SIGN_IN, SIGN_UP, VERIFY_EMAIL } from 'src/containers/Core/Paths';
import SignIn from 'src/containers/UserManagement/SignIn';
import SignUp from 'src/containers/UserManagement/SignUp';
import VerifyEmail from 'src/containers/UserManagement/VerifyEmail';

const PreSignInRoutes: React.FunctionComponent = () => {
  const { isPhoneView, isTabView } = useContext(AppViewContext);

  return (
    <div className="h-100 w-100 m-auto overflow-auto ">
      {!isPhoneView ? (
        <Row className="m-0 p-0 mt-4">
          <img height={55} src={BludotLogo} alt="Open Rewards Logo" />
        </Row>
      ) : null}
      <Row className={`align-items-center justify-content-center pb-2 m-0 p-0`} style={{ height: 'calc(100% - 80px)' }}>
        {!isPhoneView ? (
          <Col className={`text-center d-flex flex-column`} xl={{ span: 4, offset: 1 }} md={{ span: 4, offset: 1 }}>
            <LayoutCarousel />
          </Col>
        ) : null}
        <Col
          xl={{ span: 4, offset: 1 }}
          lg={{ span: 5, offset: 0 }}
          md={isTabView ? 8 : 6}
          className={`m-auto overflow-auto`}
        >
          <Switch>
            <Route
              path={SIGN_IN}
              render={(props: RouteComponentProps<{}, {}, Partial<{ token: string }>>) => <SignIn {...props} />}
            />
            <Route
              path={SIGN_UP}
              render={(
                props: RouteComponentProps<{}, {}, Partial<{ token: string; email: string; entity_name: string }>>
              ) => <SignUp {...props} />}
            />
            <Route
              path={FORGOT_PASSWORD}
              component={lazy(() => import('src/containers/UserManagement/ForgotPassword'))}
            />
            <Route path={SET_PASSWORD} component={lazy(() => import('src/containers/UserManagement/SetPassword'))} />
            <Route
              path={VERIFY_EMAIL}
              render={(props: RouteComponentProps<{}, {}, Partial<{ email: string }>>) => <VerifyEmail {...props} />}
            />
            <Route render={() => <Redirect to={SIGN_UP} />} />
          </Switch>
        </Col>
      </Row>
    </div>
  );
};

export default PreSignInRoutes;
